import { isAxiosError } from 'axios';

import RequestBuilder, { ErrorHandler, Significance } from '@/scripts/helpers/Request/Builder/RequestBuilder';
import { RoutingSymfony } from '@/scripts/player/mobile/helpers/routing';
import { UserSessionStateC } from '../types/userSession';
import type { UserSessionState } from '../types/userSession';

export const getUserSessionState = async (): Promise<UserSessionState> => {
    try {
        return await new RequestBuilder(UserSessionStateC)
            .setMethod('GET')
            .setUrl(RoutingSymfony.generate('check_user_session'))
            .setSignificance(Significance.Invisible)
            .setErrorHandler(ErrorHandler.None)
            .allow403()
            .build()
            .send();
    } catch (e: unknown) {
        if (isAxiosError(e) && e.response) {
            return {
                shouldLogout: e.response.status !== 403,
                reason: null,
                isAccountDeleted: false,
            };
        }

        throw e;
    }
};
